/**
 * "How far people watch": for each twentieth of a video, the share of its plays that watched it
 * (docs/analytics.md §5 `retention`). A line from the start to the end of the video on a 0–100%
 * axis, with a faint wash under it; the readout names the moment in the video.
 */

import { clock, percent } from "../format";
import { LineChart } from "./line-chart";

export function RetentionCurve({ retention, durationSeconds, title }: { retention: readonly number[]; durationSeconds?: number; title: string }) {
  const at = (i: number) => (durationSeconds ? clock((i / retention.length) * durationSeconds) : percent(i / retention.length));
  const labels = retention.map((_, i) => at(i));
  const pointLabels = retention.map((_, i) => `${durationSeconds ? `At ${at(i)}` : `At ${percent(i / retention.length)} of the way`}`);
  const half = retention.findIndex((share) => share < 0.5);
  const description = retention.length
    ? `${percent(retention[0])} of plays watched the start and ${percent(retention[retention.length - 1])} reached the end${half > 0 ? `; under half were still watching by ${at(half)}` : ""}.`
    : "No plays yet.";
  return (
    <LineChart title={title} description={description} labels={labels} yMax={1} integer={false} area
      series={[{ id: "retention", label: "Share of plays", values: retention, kind: "current", pointLabels }]}
      format={(v) => `${percent(v)} still watching`} tickFormat={(v) => percent(v)} />
  );
}
